import {use} from 'react'

import {AddFieldModalContext} from './add-field-modal-state-provider'

export const useAddFieldModal = () => {
  const context = use(AddFieldModalContext)
  if (!context) {
    throw new Error('useAddFieldModal must be used within a AddFieldModalContextProvider')
  }

  return context
}
